import ContractDetail from "features/Agent/Contract/Detail";

function DetailContractScreen() {
  return <ContractDetail />;
}

export default DetailContractScreen;
